"use client";
import { useEffect, useState } from "react";
import { UAParser } from "ua-parser-js";
import { useAtom } from "jotai";
import { windowSizeAtom, uaParserAtom } from "@/scripts/store";

export default function Page() {
  const [windowSize, set_windowSize] = useAtom(windowSizeAtom);
  const [uaParser, set_uaParser] = useAtom(uaParserAtom);

  useEffect(() => {
    const parserResult = UAParser();
    set_uaParser(parserResult);
    if (typeof window !== "undefined") {
      const handleResize = () => {
        let scale = 1
        if(window.innerWidth<1024) {
          scale = window.innerWidth/390
        } else if(window.innerWidth>=1024 && window.innerWidth<1408) {
          scale = window.innerWidth/1408
        } else if(window.innerWidth<=1408) {
          scale = 1
        }

        let scaleKv = 1
        if(window.innerWidth<1024) {
          scaleKv = window.innerWidth/390
        } else {
          scaleKv = window.innerWidth/1408
        }

        document.body.style.setProperty("--scale", scale.toString());
        document.body.style.setProperty("--scaleKv", scaleKv.toString());
        set_windowSize({
          width: window.innerWidth,
          height: window.innerHeight,
          scale,
        });
      };
      window.addEventListener("resize", handleResize);
      handleResize();
      document.body.classList.add("ready");
      return () => window.removeEventListener("resize", handleResize);
    } else {
      return;
    }
  }, []);
  return <></>;
}
